<template>
  <section>
    <h3 class="h3Title">메일 발송</h3>
    <div class="fieldWrap">
      <ul class="fieldBx">
        <li class="formList">
          <dl>
            <dt class="formTit">회원 구분</dt>
            <dd class="d-flex align-center">
              <v-col class="d-flex" sm="3">
                <v-select v-model="param.searchState" :items="userStateItems" item-text="label"
                          item-value="value" label="상태"
                          dense solo flat outlined clearable/>
              </v-col>
              <v-col class="d-flex" sm="3">
                <v-select v-model="param.searchRole" :items="userRoleItems" item-text="roleName"
                          item-value="roleId" label="역할"
                          dense solo flat outlined clearable/>
              </v-col>
              <v-col class="d-flex" sm="3">
                <v-select v-model="param.searchGroup" :items="departmentItems" item-value="groupId"
                          item-text="groupName"
                          dense
                          flat
                          solo
                          clearable
                          outlined
                          label="분과"
                          v-on:change="search"/>
              </v-col>
              <v-col class="d-flex" sm="3">
                <v-select v-model="param.searchGroup" :items="clubItems" item-value="groupId" item-text="groupName"
                          dense
                          clearable
                          flat
                          solo
                          outlined
                          label="동호회"
                          v-on:change="search"/>
              </v-col>
            </dd>
          </dl>
        </li>
        <li class="formList">
          <dl>
            <dt class="formTit">포함할 회원</dt>
            <dd>
              <v-col class="mgr" sm="12">
                <user-search-component @callback-event="v => searchIncludeUsers = v"/>
              </v-col>
            </dd>
          </dl>
        </li>
        <li class="formList">
          <dl>
            <dt class="formTit">제외할 회원</dt>
            <dd>
              <v-col class="mgr" sm="12">
                <user-search-component @callback-event="v => searchExcludeUsers = v"/>
              </v-col>
            </dd>
          </dl>
        </li>
        <li class="formList">
          <dl class="wh100">
            <dt class="formTit">Mail 수신동의</dt>
            <dd class="checkSt">
              <v-radio-group class="formInRadio" v-model="param.searchMailReceive" :mandatory="true" row>
                <v-radio label="전체"/>
                <v-radio label="수신 동의" :value="true"/>
                <v-radio label="수신 거부" :value="false"/>
              </v-radio-group>
              <!--              <v-btn color="#424964" @click="search" depressed dark>검색</v-btn>-->
            </dd>
          </dl>
        </li>
        <li class="formList">
          <dl class="wh100">
            <dt class="formTit">검색 키워드</dt>
            <dd class="checkSt">
              <v-col sm="6">
                <v-text-field label="아이디/이름/이메일/휴대폰번호 검색"
                              v-model="param.searchKeyword" v-on:keyup.enter="search"
                              dense clearable flat outlined
                />
              </v-col>
              <!--              <v-btn color="#424964" @click="search" depressed dark>검색</v-btn>-->
            </dd>
          </dl>
        </li>
        <li class="searchBtn">
          <v-btn color="#424964" @click="search" depressed dark>검색</v-btn>
        </li>
      </ul>
    </div>
    <h3 class="h3Title">수신자 목록</h3>
    <div class="tableBx">
      <div class="tableBtnBx">
        <p class="searchAll">
          <v-checkbox class="mgr" label="" v-model="allSelected">
            <template v-slot:label>검색 된 총 <span class="txtPoint"> {{ totalItems }}명 </span> 선택</template>
          </v-checkbox>
        </p>
        <div class="tableBtn">
          <ul>
            <li class="tableBtnList" v-if="!allSelected">
              <span class="black-color">{{ selected != null ? selected.length : 0 }}</span> 명 선택됨
            </li>
            <li class="tableBtnList" v-else><span class="red--text">검색된 전체 회원 선택됨</span></li>
            <li class="tableBtnList" style="width: 400px">
              <vue-tags-input
                  v-model="includeMail"
                  :tags="includeMails"
                  @tags-changed="addMail"
                  :validation="[{
                      classes: 'no-numbers',
                      rule: /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i,
                      disableAdd: true
                    }]"
                  placeholder="추가 이메일 주소 입력 후 enter"
              />
            </li>
          </ul>
        </div>
      </div>
      <div class="">
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="userList"
            :server-items-length="totalItems"
            :options.sync="options"
            :loading="listLoading"
            item-key="userId"
            show-select
            class="elevation-1"
            :footer-props="{showFirstLastPage: true}"
            disable-sort

        >
          <template v-slot:item.state="{value}">
            {{ userStateItems.filter(i => i.value === value)[0].text }}
          </template>
          <template v-slot:item.userHasRoles="{value}">
            <!--            {{ $t(value) }}-->
            <span
                class="d-inline-block text-truncate"
                style="max-width: 100px;"
            >
              {{ value.length > 0 ? value.length > 1 ? value[0].role.roleName + ' 외 ' + (value.length-1)  : value[0].role.roleName : '' }}
              <!--              <template v-for="(role, index) in item.userHasRoles"><span v-if="index !== 0"  :key="index">, </span>{{role.role.roleName}}</template>-->
            </span>

          </template>
          <template v-slot:item.userId="{value}">
            {{ value.length > 12 ? value.substring(0, 12) + "..." : value }}
          </template>
          <template v-slot:item.birthDate="{value, item}">
            {{ value }} {{ value != null ? item.lunarBirth ? '(음력)' : '(양력)' : '' }}
          </template>

          <template v-slot:item.createdAt="{ value }">
            {{ value | moment('YYYY-MM-DD HH:mm:ss') }}
          </template>

          <template v-slot:item.departmentGroup="{value}">
            {{  userGroupName(value) }}
          </template>
          <template v-slot:item.clubGroup="{value}">
            {{  userGroupName(value) }}
          </template>

        </v-data-table>
      </div>
    </div>
    <h3 class="h3Title">메일 작성</h3>
    <mail-component
        :param="param"
        :all-selected="allSelected"
        :selected="selected"
        :include-mail-list="send.includeMailList"
    />
  </section>
</template>

<script>
import MailComponent from "@/views/component/MailComponent";
// import translationApi from "@/api/translation"

import userApi from '@/api/UserApi'
import roleApi from '@/api/RoleApi'
import groupApi from "@/api/GroupApi";
import mailApi from "@/api/MailApi"

import VueTagsInput from '@johmun/vue-tags-input';

import userSearchComponent from "@/views/component/UserSearchComponent";

export default {
  name: "MailSend",
  components: {MailComponent, VueTagsInput, userSearchComponent},
  data: () => ({
    param: {},
    userStateItems: [],
    userRoleItems: [],
    departmentItems: [],
    clubItems: [],
    includeMail: '',
    includeMails: [],
    userType: ['이름'],
    userGradeItems: [],
    userList: [],
    user: {},
    listLoading: true,
    options: {
      page: 1,
      itemsPerPage: 10
    },
    allSelected: false,
    send: {
      title: null,
      contents: '',
      sendUserIdList: [],
      allSelected: false,
      searchParam: {}
    },
    searchValue: null,
    totalItems: 0,
    selected: [],
    headers: [
      {text: '역할', value: 'userHasRoles', align: 'left'},
      {text: '이름', value: 'name', align: 'left'},
      {text: '아이디', value: 'userId', align: 'left'},
      {text: '분과', value: 'departmentGroup', align: 'left'},
      {text: '동호회', value: 'clubGroup', align: 'left'},
      {text: '이메일', value: 'email', align: 'left'},
      {text: '부서', value: 'retirementDepartment', align: 'left'},
      {text: '생년월일', value: 'birthDate'},
      {text: '휴대폰번호', value: 'mobileNo'}
    ],
    fileMeta: {},
    ids: []
  }),
  watch: {
    options: {
      handler() {
        this.search()
      },
      deep: true,
    },
  },
  methods: {
    userGroupName(value) {
      const approvalList = value?.filter(v => v.joinState === 'STATE_APPROVAL')??[];
      const approvalSize = approvalList.length;
      const masterGroup = approvalList?.[0]?.groupName??'';

      return masterGroup + (approvalSize > 1 ? ' 외 ' + (approvalSize-1) : '')
    },
    addMail(value) {
      this.send.includeMailList = value.map(v => v.text);
    },
    search() {
      this.listLoading = true;
      const params = {...this.param, ...this.options};
      if (this.activeItem > 0) {
        params.fromDate = this.searchDate[0];
        params.toDate = this.searchDate[1];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }

      params.searchIncludeUsers = this.searchIncludeUsers?.map(o => o.userId) ?? null;
      params.searchExcludeUsers = this.searchExcludeUsers?.map(o => o.userId) ?? null;
      params.searchMailReceive = (this.param.searchMailReceive === true || this.param.searchMailReceive === false) ? this.param.searchMailReceive : null;

      userApi.list(params).then(data => {
        this.userList = data.content;
        // this.selected = [...this.selected, ...this.userList]
        this.totalItems = data.totalElements;
        this.listLoading = false;
        this.selected = [];
      });
    },
    uploadImage(f) {
      mailApi.uploadImage(f).then(res => {
        this.fileMeta = res;
      });
    }
  },
  async created() {
    this.ids = this.$route.params.ids;

    userApi.stateList().then(data => {
      // console.log(data);
      this.userStateItems = data;
    });
    roleApi.list(true).then(data => {
      this.userRoleItems = data;
    });
    groupApi.flatList(1).then(data => {
      this.departmentItems = data;
    });
    groupApi.flatList(2).then(data => {
      this.clubItems = data;
    });
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h3Title {
  @include h3-title;
}

.col {
  padding: 0;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
          flex: 0 0 80px;
        }

        dd {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}

.tableBtnBx {
  display: flex;
  align-items: center;
  justify-content: space-between;

  ul {
    display: flex;
    flex-direction: row;
    align-items: center;

    .tableBtnList {
      margin-right: 15px;
    }
  }

  .searchAll {
    display: flex;
    align-items: center;
    margin-bottom: 0;
    /*font-size: 13px;*/
    .txtPoint {
      color: $point-color;
    }
  }
}

.formInfo {
  @include form-info;
}

</style>
